var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 34.56C44.7719 35.6631 44.205 36.6674 43.3786 37.4329C42.5522 38.1984 41.5074 38.6868 40.3901 38.83C34.9408 39.6034 29.444 39.9943 23.9401 40C18.4365 39.9854 12.9404 39.5945 7.49011 38.83C6.3728 38.6868 5.32805 38.1984 4.50163 37.4329C3.67521 36.6674 3.10834 35.6631 2.88011 34.56C2.27879 31.0725 1.98433 27.539 2.00011 24C1.98433 20.461 2.27879 16.9275 2.88011 13.44C3.10834 12.3369 3.67521 11.3326 4.50163 10.5671C5.32805 9.80162 6.3728 9.31321 7.49011 9.17C12.9394 8.39651 18.4362 8.00555 23.9401 8C29.4472 8.00975 34.947 8.40068 40.4001 9.17C41.5156 9.31515 42.5582 9.80443 43.3826 10.5697C44.2071 11.3351 44.7725 12.3384 45.0001 13.44C45.6515 16.9226 45.9862 20.457 46.0001 24C45.9304 27.54 45.5961 31.0698 45.0001 34.56Z",
    fill: "url(#paint0_linear_1_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M32.35 22.44L20.92 14.82C20.638 14.6286 20.309 14.5179 19.9686 14.4999C19.6283 14.4819 19.2895 14.5573 18.9888 14.7179C18.6882 14.8786 18.4372 15.1183 18.2629 15.4112C18.0886 15.7041 17.9977 16.0391 18 16.38V31.62C17.9987 31.8672 18.0464 32.1123 18.1404 32.341C18.2345 32.5697 18.3729 32.7774 18.5477 32.9523C18.7226 33.1271 18.9303 33.2655 19.159 33.3596C19.3877 33.4536 19.6328 33.5013 19.88 33.5C20.235 33.4873 20.5801 33.3803 20.88 33.19L32.31 25.56C32.5679 25.3895 32.7795 25.1578 32.9259 24.8856C33.0723 24.6133 33.1489 24.3091 33.1489 24C33.1489 23.6909 33.0723 23.3866 32.9259 23.1143C32.7795 22.8421 32.5679 22.6104 32.31 22.44H32.35Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M20.68 15.24L31.47 22.43C32.16 22.93 32.62 23.37 32.62 23.94C32.6283 24.2058 32.5672 24.4692 32.4427 24.7042C32.3182 24.9392 32.1346 25.1377 31.91 25.28C31.54 25.55 20.91 32.64 20.91 32.64C20.01 33.25 18.55 33.12 18.55 31.14V16.74C18.5 14.74 20.08 14.84 20.68 15.24Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31.5699V16.4299C19.0002 16.2613 19.0462 16.0958 19.1332 15.9513C19.2202 15.8068 19.3449 15.6887 19.4938 15.6096C19.6428 15.5305 19.8105 15.4934 19.9789 15.5023C20.1473 15.5111 20.3102 15.5656 20.45 15.6599L31.8 23.2299C31.9279 23.3148 32.0328 23.4299 32.1054 23.5652C32.1779 23.7004 32.2159 23.8515 32.2159 24.0049C32.2159 24.1584 32.1779 24.3095 32.1054 24.4447C32.0328 24.5799 31.9279 24.6951 31.8 24.7799L20.45 32.3399C20.3102 32.4342 20.1473 32.4888 19.9789 32.4976C19.8105 32.5065 19.6428 32.4694 19.4938 32.3903C19.3449 32.3112 19.2202 32.193 19.1332 32.0485C19.0462 31.904 19.0002 31.7386 19 31.5699Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_83",
    x1: 9.82011,
    y1: 9.87,
    x2: 41.2501,
    y2: 41.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b10b802bab9815b7c36620bc1bdddf1a.svg";
export { ForwardRef as ReactComponent };